import { render } from "./course-content.vue?vue&type=template&id=0f136c3d&ts=true"
import script from "./course-content.vue?vue&type=script&lang=ts"
export * from "./course-content.vue?vue&type=script&lang=ts"

import "./course-content.vue?vue&type=style&index=0&id=0f136c3d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__